import { Stowage } from 'src/types/ViewModel/Stowage/Stowage';

export const createStowageItemChangeData = (stowageItem: Stowage): Partial<Stowage> => {
    return {
        tankId: stowageItem.tankId,
        cargoOperationGuid: stowageItem.cargoOperationGuid,
        weight: stowageItem.weight,
    };
};
